import { render, staticRenderFns } from "./SvgRenderMenu.vue?vue&type=template&id=2aeb799f"
import script from "./SvgRenderMenu.vue?vue&type=script&lang=js"
export * from "./SvgRenderMenu.vue?vue&type=script&lang=js"
import style0 from "./SvgRenderMenu.vue?vue&type=style&index=0&id=2aeb799f&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports